module.exports = __webpack_public_path__ + "img/video-control--back15.a6b3427e.svg";